'use client';

import { useRef, useState } from 'react';
import { UserImpressionType } from '@trucksmarter/shared';
import { useImpression } from '../shared/ImpressionsProvider/ImpressionsProvider';
import DallasDialog from '../Dallas/Dialogs/DallasDialog';
import FeedbackForm from './FeedbackForm';
import DallasStack from '../Dallas/Stack/DallasStack';
import DallasText from '../Dallas/Text/DallasText';
import DallasImageShootingStar from '../Dallas/Images/ShootingStar/DallasImageShootingStar';

import styles from './FeedbackDialog.module.scss';

const AUTO_DISMISS_TIMEOUT_MS = 3_000;

interface Props {
  onClose: () => void;
}

export default function FeedbackDialog({ onClose }: Props) {
  const { bumpViewCount: bumpFeedbackSubmittedViewCount } = useImpression(
    UserImpressionType.WebAppFeedbackSubmitted,
  );
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const autoDismissTimeoutRef = useRef<NodeJS.Timeout>(null);

  return (
    <DallasDialog
      className={styles.root}
      onClose={() => {
        if (autoDismissTimeoutRef.current != null) {
          clearTimeout(autoDismissTimeoutRef.current);
        }

        onClose();
      }}
      content={
        !isSubmitted ? (
          <FeedbackForm
            onSubmitted={(success) => {
              if (success) {
                bumpFeedbackSubmittedViewCount();
              }

              setIsSubmitted(true);
              autoDismissTimeoutRef.current = setTimeout(
                onClose,
                AUTO_DISMISS_TIMEOUT_MS,
              );
            }}
          />
        ) : (
          <DallasStack
            alignHorizontal="center"
            gap="md"
            paddingHorizontal="4xl"
            paddingBottom="sm"
          >
            <DallasText variant="headerRegularS" align="center">
              Thanks for your feedback!
            </DallasText>
            <DallasImageShootingStar width={170} />
          </DallasStack>
        )
      }
    />
  );
}
